module.exports = __webpack_public_path__ + "assets/images/invisible-asia/9-southkorea.jpg?v=ac2ae495";